var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<label class="nfd-checkbox"> <input class="nfd-checkbox-input"type="checkbox"data-bind="checked: props.checked, disable: props.isDisabled"> <i class="nfd-icon nfd-checkbox-icon nfd-checkbox-icon-plain"data-bind="css: { \'nfd-checkbox-icon-disabled\': props.isDisabled }"></i> <span class="nfd-filter-title nfd-text-darker nfd-checkbox-content"data-bind="css: { \'non-clickable\': props.isDisabled }"> <span data-bind="html: props.content"></span> <!-- ko template: { nodes: $componentTemplateNodes, data: $parent } --><!-- /ko --> </span> </label>';
}
return __p;
};
